<template>
  <div
    class="settle-page-wrap"
    :class="{
      'electron-settle-page-wrap': isElectron,
      'no-show-settle-form': !showSettleForm,
    }"
  >
    <div>
      <div
        :class="{
          'show-settle-form': showSettleForm,
          'no-show-settle-form': !showSettleForm,
        }"
      >
        <nav-bar
          v-if="!isH5 && !isElectron"
          class="settle-page-nav-bar"
          :class="{ 'white-bg': changeNavBarBg }"
        ></nav-bar>
        <div class="content settle-in">
          <!-- 已有机构 -->
          <div v-if="!validPass && user && user.org_id" class="settled-wrap">
            <img src="@/assets/img/bug.png" alt="" />
            您已拥有或加入机构，无法重复入驻。
            <p class="link-wrap">
              <button @click="jumpAdmin()">去管理后台</button>
            </p>
          </div>
          <!-- 机构入驻 -->
          <div v-else-if="showSettleForm">
            <div class="form-title-wrap">
              <p>魔果云课{{ org_type === 2 ? "机构" : "个人" }}入驻申请</p>
            </div>
            <div class="form-cont-wrap">
              <ul class="org-type-wrap">
                <li
                  @click="handleTypeChange(item.id)"
                  v-for="item in orgTypeList"
                  :key="item.id"
                  :class="{ active: org_type === item.id }"
                >
                  <span>{{ item.type }}</span>
                </li>
              </ul>
              <el-form
                class="settle-form"
                ref="form"
                :model="form"
                label-width="180px"
                size="medium"
                :rules="rules"
              >
                <!-- <el-form-item label="拥有者" required>
                  <el-input v-model="form.mobile" disabled></el-input>
                  <p class="tips">
                    为当前登录账号，如非实际企业相关人员，请让企业对应人员登录填写
                  </p>
                </el-form-item> -->
                <el-form-item label="拥有者电话" required>
                  <el-input v-model="form.mobile" disabled></el-input>
                  <p class="tips">根据您注册的手机号，进行展示</p>
                </el-form-item>
                <el-form-item label="拥有者姓名" prop="own_name">
                  <el-input
                    v-model.trim="form.own_name"
                    maxlength="30"
                  ></el-input>
                  <p class="tips">
                    将自动填入与账号一致的姓名，如需更改请自行填写，不会修改个人信息
                  </p>
                </el-form-item>
                <div v-if="org_type === 2">
                  <el-form-item label="公司全名" prop="company_name">
                    <el-input
                      v-model.trim="form.company_name"
                      maxlength="30"
                      placeholder="需与营业执照信息一致"
                    ></el-input>
                    <!-- <p class="tips">需与营业执照信息一致</p> -->
                  </el-form-item>
                  <el-form-item label="企业信用代码" prop="company_credit_code">
                    <el-input
                      v-model.trim="form.company_credit_code"
                      maxlength="30"
                      placeholder="需与营业执照信息一致"
                    ></el-input>
                    <!-- <p class="tips">需与营业执照信息一致</p> -->
                  </el-form-item>
                  <el-form-item
                    class="company-licence"
                    label="营业执照照片"
                    required
                  >
                    <div class="company-licence-upload">
                      <el-upload
                        accept=".jpg,.png"
                        class="avatar-uploader"
                        :class="{ 'avatar-have-uploaded': company_licence_pic }"
                        action="#"
                        :auto-upload="false"
                        :show-file-list="false"
                        :on-change="
                          (file) => handleChange(file, 'company_licence_pic')
                        "
                      >
                        <img
                          v-if="company_licence_pic"
                          :src="company_licence_pic"
                          class="avatar"
                        />
                        <i
                          v-else
                          class="avatar-uploader-icon company-licence-icon"
                        ></i>
                      </el-upload>
                      <p class="tips upload-tips">
                        <span> 请上传营业执照正本完整照片</span>
                        <span>请确保上传规格为小于10M的JPG、PNG格式图片</span>
                      </p>
                    </div>
                  </el-form-item>
                </div>
                <div v-if="org_type === 1">
                  <el-form-item label="负责人姓名" prop="leader_name">
                    <el-input
                      v-model.trim="form.leader_name"
                      maxlength="30"
                      placeholder="请保证填写信息与身份证保持一致"
                    ></el-input>
                    <!-- <p class="tips">需与上传的负责人身份证保持一致</p> -->
                  </el-form-item>
                  <el-form-item label="负责人身份证号码" prop="leader_id_card">
                    <el-input
                      v-model.trim="form.leader_id_card"
                      maxlength="18"
                      placeholder="请保证填写信息与身份证保持一致"
                    ></el-input>
                    <!-- <p class="tips">需与上传的负责人身份证保持一致</p> -->
                  </el-form-item>
                  <el-form-item
                    class="leader-id-card"
                    label="负责人身份证照片"
                    required
                  >
                    <div class="upload-wrap">
                      <el-upload
                        accept=".jpg,.png"
                        class="avatar-uploader"
                        :class="{ 'avatar-have-uploaded': leader_id_card_pic1 }"
                        action="#"
                        :auto-upload="false"
                        :show-file-list="false"
                        :on-change="
                          (file) => handleChange(file, 'leader_id_card_pic1')
                        "
                      >
                        <img
                          v-if="leader_id_card_pic1"
                          :src="leader_id_card_pic1"
                          class="avatar"
                        />
                        <i
                          v-else
                          class="avatar-uploader-icon id_card-icon1"
                        ></i>
                      </el-upload>
                      <!-- <p v-if="!leader_id_card_pic1" class="desc">
                    身份证正面（人像面）
                  </p> -->
                    </div>
                    <div class="upload-wrap">
                      <el-upload
                        accept=".jpg,.png"
                        class="avatar-uploader"
                        :class="{ 'avatar-have-uploaded': leader_id_card_pic2 }"
                        action="#"
                        :auto-upload="false"
                        :show-file-list="false"
                        :on-change="
                          (file) => handleChange(file, 'leader_id_card_pic2')
                        "
                      >
                        <img
                          v-if="leader_id_card_pic2"
                          :src="leader_id_card_pic2"
                          class="avatar"
                        />
                        <i
                          v-else
                          class="avatar-uploader-icon id_card-icon2"
                        ></i>
                      </el-upload>
                      <!-- <p v-if="!leader_id_card_pic2" class="desc">
                    身份证背面（国徽面）
                  </p> -->
                    </div>
                    <p class="tips upload-tips">
                      <span> 请上传负责人身份证正本完整照片</span>
                      <span>请确保上传规格为小于10M的JPG、PNG格式图片</span>
                    </p>
                  </el-form-item>
                </div>
                <el-form-item label="联系人" prop="contacts">
                  <el-input
                    v-model.trim="form.contacts"
                    maxlength="30"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系人电话" prop="contact_phone">
                  <el-input
                    v-model.trim="form.contact_phone"
                    maxlength="16"
                  ></el-input>
                  <p class="tips">非中国大陆用户请输入国际电话区号</p>
                </el-form-item>
                <el-form-item label="联系人地址" prop="contact_address">
                  <el-input
                    v-model.trim="form.contact_address"
                    maxlength="200"
                  ></el-input>
                </el-form-item>
                <div class="protocol-wrap">
                  <el-checkbox v-model="protocol"> </el-checkbox>我已阅读并同意
                  <a href="javascript:;" @click="jumpUrl('/org-cooperate')"
                    >机构服务合作协议</a
                  >
                </div>
              </el-form>
              <div class="footer">
                <button
                  @click="submitForm"
                  v-preventReClick
                  :disabled="loading"
                >
                  提交申请
                </button>
              </div>
            </div>
          </div>
          <div v-else class="success-wrap">
            <img src="../../assets/images/settle-in/success-img.png" alt="" />
            <div class="success-cont">
              <p class="result-text">认证通过</p>
              <p class="success-text">
                恭喜您的“{{
                  user && user.org_name ? user.org_name : ""
                }}”认证通过系统验证
              </p>
              <p class="tips">
                您现在可以
                <button @click="jumpAdmin()" class="link">进入管理后台</button
                >，或通过下方快捷入口展开下一步工作啦!
              </p>
              <p class="link-wrap">
                <button
                  @click="jumpAdmin('/organizational/personal')"
                  class="default-btn"
                >
                  添加人员
                </button>
                <button
                  @click="jumpAdmin('/teaching/course')"
                  class="primary-btn"
                >
                  创建课程
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, isH5, isMobile } from "@saas/components";
import {
  cosUploadFile,
  getObjectUrl,
} from "@saas/components/src/utils/cos-upload";
import {
  createOrganization,
  getOrgPicSts,
} from "@saas/server-api/src/settle-in";
import { vailPhone } from "@saas/components/src/utils/utils.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data: function () {
    const validateMobile = (rule, value, callback) => {
      // 校验手机号 6-16位
      if (value && (value.length < 6 || value.length > 16)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const validateCardNo = (rule, value, callback) => {
      // 15位和18位身份证号码的正则表达式
      var regIdCard =
        /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      // 如果通过该验证，说明身份证格式正确，但准确性还需计算
      if (regIdCard.test(value)) {
        if (value.length == 18) {
          var idCardWi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // 将前17位加权因子保存在数组里
          var idCardY = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
          var idCardWiSum = 0; // 用来保存前17位各自乖以加权因子后的总和
          for (var i = 0; i < 17; i++) {
            idCardWiSum += value.substring(i, i + 1) * idCardWi[i];
          }
          var idCardMod = idCardWiSum % 11; // 计算出校验码所在数组的位置
          var idCardLast = value.substring(17); // 得到最后一位身份证号码
          // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
          if (idCardMod == 2) {
            if (idCardLast == "X" || idCardLast == "x") {
              callback();
              return true;
            } else {
              callback(new Error("身份证号码错误！"));
              return false;
            }
          } else {
            // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
            if (idCardLast == idCardY[idCardMod]) {
              callback();
              return true;
            } else {
              callback(new Error("身份证号码错误！"));
              return false;
            }
          }
        } else {
          callback();
          return true;
        }
      } else {
        callback(new Error("身份证号码错误！"));
        return false;
      }
    };
    return {
      isMobile: isMobile(),
      isH5: isH5(),
      changeNavBarBg: false,
      isElectron: window.isElectron,
      protocol: false,
      orgTypeList: [
        {
          id: 2,
          type: "企业入驻",
        },
        {
          id: 1,
          type: "个人入驻",
        },
      ],
      org_type: 2,
      form: {
        mobile: "",
        own_name: "",
        company_credit_code: "",
        company_name: "",
        contact_address: "",
        contact_phone: "",
        contacts: "",
        leader_name: "",
        leader_id_card: "",
      },
      company_licence_pic: "",
      leader_id_card_pic1: "",
      leader_id_card_pic2: "",
      company_licence_pic_key: "",
      leader_id_card_pic1_key: "",
      leader_id_card_pic2_key: "",
      rules: {
        own_name: [{ required: true, message: "必填项", trigger: "blur" }],
        leader_name: [{ required: true, message: "必填项", trigger: "blur" }],
        leader_id_card: [
          { required: true, message: "必填项", trigger: "blur" },
          { validator: validateCardNo, trigger: "blur" },
        ],
        contacts: [{ required: true, message: "必填项", trigger: "blur" }],
        contact_phone: [
          { required: true, message: "必填项", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        contact_address: [
          { required: true, message: "必填项", trigger: "blur" },
        ],
        company_name: [{ required: true, message: "必填项", trigger: "blur" }],
        company_credit_code: [
          { required: true, message: "必填项", trigger: "blur" },
        ],
      },
      adminUrl: process.env.VUE_APP_ADMIN_URL,
      webUrl: process.env.VUE_APP_SAAS_WEB_URL,
      validPass: false,
      loading: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.inintFormData();
    }, 500);
    // 监听滚动
    window.addEventListener("scroll", this.handleScroll, true);
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener("scroll", this.handleScroll, true);
    clearInterval(this.timer);
  },
  methods: {
    ...mapActions(["getProfile"]),
    ...mapActions("user", ["getInfo"]),
    jumpAdmin(href = "", type) {
      let url = this.adminUrl + href;
      if (window.isElectron) {
        window.openUrlByExternal(url);
      } else if (this.isMobile) {
        window.location.href = url;
      } else {
        if (type === "auto") {
          window.location.href = url;
        } else {
          window.open(url);
        }
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement?.scrollTop || 0;
      let height = document.querySelector(".nav-bar")?.offsetHeight || 0;
      if (scrollTop > height) {
        this.changeNavBarBg = true;
      } else {
        this.changeNavBarBg = false;
      }
    },
    jumpUrl(url) {
      if (window.isElectron) {
        window.openUrlByExternal(this.webUrl + url);
      } else {
        window.open(url);
      }
    },
    handleTypeChange(id) {
      this.org_type = id;
      if (this.$refs["form"]) {
        this.$refs["form"].clearValidate();
      }
    },
    // 获取凭证
    getUploadFileSts(file, name) {
      getOrgPicSts({ filename: file.name }).then(async (res) => {
        if (res.code === 1) {
          let key = name + "_key";
          this[key] = res.data.key;
          cosUploadFile(
            {
              file: file.raw,
              fileName: file.name,
            },
            { ...res.data },
            {
              onTaskReady: (taskId) => {
                console.log("taskId>>>>", taskId);
              },
              onProgress: (progerssData) => {
                console.log("progerssData>>>>", progerssData);
              },
              onFileFinish: (err, data, options) => {
                console.log("onFileFinish-data", data);
                console.log("onFileFinish-options", options);
                if (data && data.statusCode === 200) {
                  const url = getObjectUrl(res.data);
                  this[name] = url;
                  // this[name] = data.Location.startsWith("https://")
                  //   ? data.Location
                  //   : "https://" + data.Location;
                } else {
                  console.log(err);
                }
              },
            }
          );
        }
      });
    },
    submitForm() {
      //   校验
      this.$refs.form.validate((valid) => {
        if (valid) {
          //图片是否上传
          if (this.org_type === 2 && !this.company_licence_pic) {
            this.$message.warning("请上传营业执照照片");
            return false;
          } else if (
            this.org_type === 1 &&
            (!this.leader_id_card_pic1 || !this.leader_id_card_pic2)
          ) {
            this.$message.warning("请上传负责人身份证照片");
            return false;
          }
          // 协议
          if (!this.protocol) {
            this.$message.warning("请先阅读并同意机构服务合作协议");
            return false;
          }
          //   提交
          let {
            own_name = "",
            leader_name = "",
            leader_id_card = "",
            contacts = "",
            contact_phone = "",
            contact_address = "",
            company_name = "",
            company_credit_code = "",
          } = this.form;
          let otherParams = {};
          if (this.org_type === 1) {
            // 个人
            otherParams = {
              leader_name,
              leader_id_card,
              leader_id_card_pic: JSON.stringify([
                this.leader_id_card_pic1_key,
                this.leader_id_card_pic2_key,
              ]),
            };
          } else if (this.org_type === 2) {
            //公司
            otherParams = {
              company_name,
              company_credit_code,
              company_licence_pic: this.company_licence_pic_key,
            };
          }
          let params = {
            org_type: this.org_type,
            own_name,
            contact_address,
            contact_phone,
            contacts,
            ...otherParams,
          };
          if (this.loading) return;
          this.loading = true;
          createOrganization(params)
            .then((res) => {
              if (res.code === 1) {
                this.validPass = true;
                // 更新用户信息
                if (window.isElectron) {
                  this.getInfo();
                } else {
                  this.getProfile();
                }
                this.autoJumpAdmin();
              } else {
                this.$message.error(res.message);
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    autoJumpAdmin() {
      let time = 5;
      this.$confirm(
        `<span id='settle-in-success-timed'>${time}</span>s后自动进入后台`,
        "恭喜您完成入驻",
        {
          center: true,
          showCancelButton: false,
          confirmButtonText: "进入您的专属后台",
          customClass: "saas-confirm-message",
          confirmButtonClass: "confirm-btn",
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.jumpAdmin();
          clearInterval(this.timer);
        })
        .catch(() => {
          clearInterval(this.timer);
        });
      this.timer = setInterval(() => {
        time--;
        document.getElementById("settle-in-success-timed").innerHTML = time; //实现动态渲染
        if (time == 0) {
          clearInterval(this.timer);
          this.$msgbox.close(false); //关闭弹窗
          this.jumpAdmin("", "auto");
        }
      }, 1000);
    },
    inintFormData() {
      this.form.mobile = this.user.mobile;
      this.form.own_name = this.user.username || "";
    },
    handleChange(file, name) {
      const isImageType = ["image/jpeg", "image/png"].includes(file.raw.type);
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isImageType) {
        this.$message.warning("上传图片只能是 JPG、PNG 格式!");
        return false;
      }
      if (!isLt10M) {
        this.$message.warning("上传图片大小不能超过 10M!");
        return false;
      }
      this.getUploadFileSts(file, name);
    },
  },
  computed: {
    ...mapGetters(["user"]),
    showSettleForm() {
      if (!this.validPass && this.user?.org_id) {
        return false;
      } else if (!this.validPass && !this.user?.org_id) {
        return true;
      } else {
        return false;
      }
    },
  },
  components: {
    "nav-bar": NavBar,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .settle-form .el-form-item {
  margin-bottom: 20px;
}
::v-deep .settle-form .el-form-item__label {
  padding: 0 20px 0 0;
  color: $chiral-color;
}
::v-deep .settle-form .el-form-item__content {
  width: 416px;
}
::v-deep .settle-form .el-input.is-disabled .el-input__inner {
  background: #f2f3f5;
  border-radius: 6px;
  border: none;
  color: #858687;
}
::v-deep .settle-form .el-input .el-input__inner::placeholder {
  font-size: 13px;
  color: rgba($color: #747573, $alpha: 0.8);
}
::v-deep .leader-id-card .el-form-item__content {
  width: 100%;
}
::v-deep .company-licence .el-form-item__content {
  width: 100%;
}
.settle-page-wrap {
  background: linear-gradient(180deg, #e7f3eb 0%, #ffffff 100%, #ffffff 100%);
}
.settle-page-wrap .show-settle-form {
  background: url("../../assets/images/video-play/bg.png");
  background-position: top center;
  background-size: 100% 728px;
  background-repeat: no-repeat;
  .settle-in {
    background: transparent;
  }
}
.no-show-settle-form {
  background: #fff;
}
.settle-in {
  background: transparent !important;
  padding-bottom: 60px;
  overflow-x: hidden;
  .form-title-wrap {
    display: flex;
    justify-content: center;
  }
  .form-title-wrap p {
    position: relative;
    padding-top: 70px;
    font-weight: 600;
    font-size: 40px;
    color: #0d1400;
    line-height: 32px;
    margin-bottom: 70px;
    text-align: center;
  }
  .form-cont-wrap {
    width: 700px;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
    border-radius: 24px;
    margin: 0 auto;
    padding-top: 40px;
  }
  .org-type-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 300px;
    height: 38px;
    border-radius: 8px;
    border: 1px solid #f2f3f5;
    padding: 4px;
    margin: 0 auto;
    margin: 0 auto 40px;
    .active {
      background: #e5fbf3;
      border-radius: 8px;
      span {
        font-weight: 600;
        font-size: 16px;
        background: linear-gradient(
          41.94400710581127deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      line-height: 22px;
      background: #e5fbf3;
    }
    li {
      width: 140px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 16px;
      color: #222426;
      line-height: 22px;
      cursor: pointer;
    }
  }
  .settle-form .tips {
    font-weight: 400;
    font-size: 12px;
    color: #858687;
    line-height: 22px;
    margin-top: 6px;
    margin-left: 4px;
  }
  .leader-id-card .upload-wrap {
    height: 158px;
    position: relative;
    display: inline-block;
    margin-right: 10px;
    .avatar-uploader {
      position: relative;
      &:not(.avatar-have-uploaded)::after {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        content: "";
        width: 24px;
        height: 24px;
        background: url("../../assets/images/settle-in/camera-icon.png");
        background-size: 100% 100%;
        pointer-events: none;
      }
    }

    // .desc {
    //   position: absolute;
    //   bottom: 11px;
    //   left: 50%;
    //   transform: translate(-50%, 0);
    //   font-size: 12px;
    //   color: #999999;
    //   line-height: 20px;
    // }
  }
  .leader-id-card .upload-tips {
    display: inline-block;
    position: absolute;
    left: 0;
    bottom: 0;
    span {
      display: block;
    }
    font-weight: 400;
    font-size: 12px;
    color: #858687;
    line-height: 17px;
    margin: 0;
  }
  .company-licence-upload .avatar-uploader {
    display: inline-block;
    margin-right: 10px;
  }
  .company-licence-upload .upload-tips {
    display: inline-block;
    span {
      display: block;
    }
    font-weight: 400;
    font-size: 12px;
    color: #858687;
    line-height: 17px;
    margin: 0;
  }
  .protocol-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 40px 0 12px;
    font-size: 14px;
    color: #515350;
    line-height: 20px;
    .el-checkbox {
      margin-bottom: 1px;
    }
    a {
      color: #00c89d;
    }
  }
  .footer {
    text-align: center;
    padding-bottom: 60px;
    button {
      width: 260px;
      height: 50px;
      border-radius: 12px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 22px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    }
  }

  // 已入驻
  .settled-wrap {
    padding-top: 110px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    img {
      width: 150px;
      height: 150px;
      margin-bottom: 30px;
    }
    .link-wrap {
      margin-top: 20px;
      color: $saas-theme-color;
    }
  }

  // 入驻成功
  .success-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 110px;
    img {
      width: 200px;
      height: 160px;
    }
    .result-text {
      font-weight: 600;
      font-size: 24px;
      color: #0d1400;
      line-height: 33px;
      margin-bottom: 8px;
      text-align: center;
    }
    .success-text {
      font-weight: 600;
      font-size: 18px;
      color: #0d1400;
      line-height: 25px;
      text-align: center;
      margin-bottom: 12px;
    }
    .tips {
      font-weight: 400;
      font-size: 14px;
      color: #0d1400;
      line-height: 20px;
      .link,
      a {
        color: rgba(0, 200, 157, 1);
      }
    }
    .link-wrap {
      display: flex;
      justify-content: center;
      margin-top: 30px;
      margin-bottom: 40px;
      .default-btn,
      .primary-btn {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .default-btn {
        width: 100px;
        height: 36px;
        border-radius: 8px;
        background: #f7f8f9;
        font-weight: 400;
        font-size: 14px;
        color: #0d1400;
        line-height: 22px;
        margin-right: 16px;
      }
      .primary-btn {
        width: 100px;
        height: 36px;
        border-radius: 8px;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        font-weight: 600;
        font-size: 14px;
        color: #ffffff;
        line-height: 22px;
      }
    }
  }

  // 上传组件
  .avatar-uploader {
    display: inline-block;
    width: 166px;
    height: 112px;
    border-radius: 8px;
    border: 1px solid #e5e6eb;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &.avatar-have-uploaded::after {
      position: absolute;
      left: 0;
      bottom: 0;
      display: block;
      content: "更换图片";
      width: 166px;
      height: 24px;
      background: rgba($color: #000000, $alpha: 0.6);
      border-radius: 0px 0px 8px 8px;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      line-height: 24px;
      pointer-events: none;
    }
  }

  .avatar-uploader-icon {
    display: inline-block;
    width: 166px;
    height: 112px;
    background-size: 150px auto;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .company-licence-icon {
    background-image: url("../../assets/images/settle-in/company-licence-bg.png");
  }
  .id_card-icon1 {
    background-image: url("../../assets/images/settle-in/id-card-bg1.png");
  }
  .id_card-icon2 {
    background-image: url("../../assets/images/settle-in/id-card-bg2.png");
  }
  .avatar {
    width: 166px;
    height: 112px;
    display: block;
  }
}
.settle-in .el-button.is-disabled {
  color: #ffffff !important;
  background-color: $saas-theme-color !important;
  border-color: $saas-theme-color !important;
}

// nav-bar
::v-deep .settle-page-nav-bar {
  .nav-bar {
    background: rgba($color: #fff, $alpha: 0.4);
  }
}
::v-deep .white-bg.settle-page-nav-bar {
  .nav-bar {
    background: #fff;
  }
}

// electron
.settle-page-wrap.electron-settle-page-wrap {
  background: #fff;
  & > div {
    background: linear-gradient(180deg, #e7f3eb 0%, #ffffff 100%, #ffffff 100%);
  }
  .show-settle-form {
    background: url("../../assets/images/video-play/bg.png");
    background-position: top center;
    background-size: 100% 728px;
    background-repeat: no-repeat;
  }
  .settle-in {
    background: transparent;
  }
  &.no-show-settle-form {
    background: transparent;
    & > div {
      background: transparent;
    }
    .no-show-settle-form {
      background: transparent;
    }
  }
}
</style>
